import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {ViewGoalContainerState} from '../state';
import {Display, Layout, Panel} from 'components';
import GoalDetails from './GoalDetails';
import ProgressUpdateList from './ProgressUpdateList';
import EditGoalModal from '../../EditGoalModal';
import DeleteProgressUpdateModal from './DeleteProgressUpdateModal';

const ViewGoalContainer = observer(({uiState}) => {
  const {backTitle, backPath} = uiState;

  return (
    <div className='mb1'>
      <Display backTitle={backTitle} backPath={backPath} />
      <Layout>
        <Panel.Stack>
          <GoalDetails uiState={uiState}/>
          <ProgressUpdateList uiState={uiState}/>
        </Panel.Stack>
      </Layout>
      <EditGoalModal uiState={uiState} />
      <DeleteProgressUpdateModal uiState={uiState} />
    </div>
  );
});

export default withState(ViewGoalContainer, ViewGoalContainerState);
